/* istanbul ignore file */
/**
 * Cancellable fetch lib
 *
 * @packageDocumentation
 */
export { cancelFetch, fetch, fetch$ } from './fetch.js';
export { credentialsInterceptor, composeFetch, composeFetch$, composeFetchResponse, composeFetch$Response, } from './interceptors.js';
import { registerLibrary } from '@onviobr/app-information';
registerLibrary({
    name: '@onviobr/fetch',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "1.1.3",
});
